// Portal › İçe Aktar — /portal/kpi/import (M16 T19, C3): mevcut ImportWizard portal API'siyle
// (`PORTAL_IMPORT_API`), `isClient` modunda: `create` seçeneği ve işletme kolonu düzenleme YOK
// (eşlenmemiş işletme → "danışmanınıza iletin"), AI Kontrolü paneli render edilmez, 400
// KPI_CLIENT_FORBIDDEN_ACTION / 403 anlaşılır metin. Grid bağlamı portal store'dan (gridCtx).

import { useState } from "react";
import { PORTAL_IMPORT_API } from "../../api/portal-kpi";
import { EmptyState, LoadingState } from "../../components/common/StateSurface";
import { ImportWizard } from "../../components/kpi/import/ImportWizard";
import { KpiPageHeader } from "../../components/kpi/KpiPageHeader";
import { PortalKpiBar } from "../../components/kpi/PortalKpiBar";
import { KPI_COPY } from "../../lib/kpi-ui";
import { usePortalKpiStore } from "../../stores/portal-kpi-store";

const P = KPI_COPY.portal;

const btn: React.CSSProperties = {
  padding: "6px 12px",
  borderRadius: 8,
  border: "1px solid var(--color-border)",
  background: "var(--color-surface)",
  fontSize: "0.82rem",
  color: "var(--color-text)",
  minHeight: 34,
};

export function PortalKpiImportPage(): JSX.Element {
  const setsStatus = usePortalKpiStore((s) => s.setsStatus);
  const sets = usePortalKpiStore((s) => s.sets);
  const setId = usePortalKpiStore((s) => s.setId);
  const grid = usePortalKpiStore((s) => s.grid);
  const years = usePortalKpiStore((s) => s.years);
  const access = usePortalKpiStore((s) => s.access);
  const entities = usePortalKpiStore((s) => s.entities);
  const error = usePortalKpiStore((s) => s.error);
  const refreshGrid = usePortalKpiStore((s) => s.refreshGrid);
  const setYears = usePortalKpiStore((s) => s.setYears);
  const [wizardActive, setWizardActive] = useState(false);
  void wizardActive; // portalda bağlam kilidi yok (müşteri seçici yok)
  const set = sets.find((s) => s.id === setId);

  // güvenlik/UX taraması 2026-10-08 (U-H2/U-M7): yüklenemedi dallarında "Tekrar dene" — sonsuz
  // spinner / eylemsiz boş durum yok.
  const retryButton = (onClick: () => void): JSX.Element => (
    <button type="button" style={btn} onClick={onClick}>
      {P.retry}
    </button>
  );
  const retrySets = (): void => {
    const uid = usePortalKpiStore.getState().userId;
    if (uid) void usePortalKpiStore.getState().loadSets(uid, { force: true });
  };

  let body: React.ReactNode;
  if (setsStatus === "idle" || setsStatus === "loading") body = <LoadingState />;
  else if (setsStatus === "error")
    body = <EmptyState title={P.loadFailed} action={retryButton(retrySets)} />;
  else if (sets.length === 0) body = <EmptyState title={P.noAccessTitle} hint={P.noAccessBody} />;
  // M17 — denetçi içe aktaramaz (ilk yükleme 403 olurdu): sihirbaz hiç açılmaz
  else if (set?.role === "auditor")
    body = <EmptyState title={P.auditorLockTitle} hint={P.auditorBand} />;
  else if (access?.open === 0) body = <EmptyState title={P.lockTitle} hint={P.readonlyBand} />;
  else if (error && !grid)
    body = (
      <EmptyState
        title={P.loadFailed}
        hint={error}
        action={retryButton(() => void refreshGrid())}
      />
    );
  else if (!set || !grid) body = <LoadingState />;
  else {
    body = (
      <>
        <div
          className="text-sm mb-3 px-3 py-2 rounded-xl"
          style={{
            background: "var(--color-bg)",
            border: "1px solid var(--color-border)",
            color: "var(--color-text-2)",
          }}
        >
          {P.import.note}
        </div>
        <ImportWizard
          key={set.id}
          clientId={set.clientId}
          setId={set.id}
          onActiveChange={setWizardActive}
          api={PORTAL_IMPORT_API}
          isClient
          basePath="/portal/kpi"
          gridCtx={{
            years,
            currentGrid: grid,
            // tam işletme listesi — grid seçili işletmeye daraltılmış olabilir (P1-1)
            entities: entities.length > 0 ? entities : grid.entities,
            refreshGrid,
            setYears,
          }}
        />
      </>
    );
  }

  return (
    <main className="p-4 sm:p-8" style={{ fontFamily: "var(--font-sans)", maxWidth: 1600 }}>
      <KpiPageHeader
        title={KPI_COPY.titles.import}
        subtitle={set ? `${set.name} — ${P.import.subtitle}` : P.import.subtitle}
      />
      {setsStatus === "ready" && sets.length > 0 ? <PortalKpiBar /> : null}
      {body}
    </main>
  );
}
